export const createUserName = (firstName, lastName) => {
  const shortLastName = lastName.slice(0, 1);
  return `${firstName}${shortLastName ? ` ${shortLastName}.` : ''}`;
};
